import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { combineLatest, Observable, of, catchError, switchMap, take } from 'rxjs';
import { LanguageService } from '@spartacus/core';

import { ConfigurationService } from './configuration.service';
import { BaseStoreService } from './base-store.service';
import { NewsletterResponse } from '../models';
import { HobMapper } from '../mappers';

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {
  constructor(
    private http: HttpClient,
    private configService: ConfigurationService,
    private readonly baseStoreService: BaseStoreService,
    private readonly languageService: LanguageService,
    private readonly hobMapper: HobMapper
  ) {}

  subscribeToNewsletter(form: any, context: string, isHob?: boolean): Observable<NewsletterResponse | undefined> {
    const language$ = this.languageService.getActive().pipe(take(1));

    return combineLatest([language$]).pipe(
      switchMap(([languageConfig]) => {
        const baseStore = this.baseStoreService.baseStore;
        const config = this.configService.config;
        const language = baseStore.languages.find((lang) => lang.isocode === languageConfig)?.langue_SF;
        const url = config.myAccount?.baseUrl + '/profiles/enriched';
        const market = baseStore.market;
        const optinPartner = 'Sovendus';
        const brand = isHob ? this.hobMapper.currentBrandToBrandEnum(baseStore.brandSite)?.toLowerCase() : config.myAccount?.brand;
        const optins = [{
          brand,
          isActive: true
        }];
        const touchpoint = 'WEB';
        const touchpointSource = 'WEBSITE';

        const headers = {
          'Ocp-Apim-Subscription-Key': config.myAccount?.subscriptionKey
        };

        const intrusiveInfo =
          form.firstName || form.lastName
            ? {
              firstName: form.firstName,
              lastName: form.lastName
            }
            : {};

        const body = {
          profile: {
            ...intrusiveInfo,
            email: form.email,
            emailQualityScore: form.emailQualityScore,
            emailQualityScoreModifiedDate: form.emailQualityScoreModifiedDate,
            phone: form.phone,
            gender: form.gender,
            brand,
            market: market,
            touchpoint: touchpoint,
            birthdate: form.birthdate,
            householdMembers: form.householdMembers
          },
          ...(form.postalCode && form.city
            ? {
              addresses: [{
                postalCode: form.postalCode,
                city: form.city,
                isMainAddress: true
              }]
            }
            : {}),
          newsletters: {
            market,
            language,
            context,
            optinPartner,
            optins,
            touchpoint,
            touchpointBrand: brand,
            touchpointSource
          }
        };

        return this.http.post<NewsletterResponse>(url, body, { headers });
      }),
      catchError(() => of(undefined))
    );
  }
}
